/* Account pages: sign-in / recovery switch, and the rewards panel's loading state. */
(() => {
  const auth = document.querySelector('[data-auth]');

  if (auth) {
    const show = (mode) => {
      if (mode === 'recover') {
        auth.dataset.mode = 'recover';
      } else {
        delete auth.dataset.mode;
      }
      const pane = auth.querySelector(`[data-pane="${mode}"]`);
      // Shopify's form tag emits a hidden form_type input first, and calling
      // focus() on it does nothing, so the switch left the caret nowhere.
      const field = pane && pane.querySelector('input:not([type="hidden"])');
      if (field) field.focus();
    };

    // The hash is the no-JavaScript fallback, so honour it on load too.
    if (location.hash === '#recover') show('recover');

    auth.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-auth-to]');
      if (!trigger) return;
      event.preventDefault();
      show(trigger.dataset.authTo);
    });
  }

  const panel = document.querySelector('[data-lion-panel]');
  if (!panel) return;

  const mount = panel.querySelector('[data-lion-account]');
  const skeleton = panel.querySelector('[data-lion-skeleton]');
  const fallback = panel.querySelector('[data-lion-fallback]');
  if (!mount) return;

  const settle = (mounted) => {
    if (skeleton) skeleton.remove();
    if (!mounted && fallback) fallback.hidden = false;
  };

  // LoyaltyLion mounts asynchronously and gives no promise to wait on, so the
  // arrival of its markup is the signal. Ten seconds is the point past which a
  // spinner stops being informative and a link is more use.
  if (mount.childElementCount > 0) {
    settle(true);
    return;
  }

  const observer = new MutationObserver(() => {
    if (mount.childElementCount === 0) return;
    observer.disconnect();
    clearTimeout(timer);
    settle(true);
  });

  observer.observe(mount, { childList: true });

  const timer = setTimeout(() => {
    observer.disconnect();
    settle(mount.childElementCount > 0);
  }, 10000);
})();
